import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { renderTableTitle } from "@/utils/render.jsx";
import orgTreeModal from "@/components/Modal/selectOrgTreeModal.vue";
import { queryApp, removeEntities } from "@/service/appList-2";
import { enterpriseMap } from "@/utils/util";
import { addApp } from "@/service/appList-2";
export default {
  name: "authorization",
  components: {
    orgTreeModal
  },
  props: {
    appdetail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      users: [],
      search: "",
      selections: [],
      columns: [{
        title: $t("p1j42", "选择"),
        key: "select",
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: $t("a78yyj4", "主体名称"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "name",
        align: "center",
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => {
          return h("div", {
            "class": "text-left"
          }, [row.name]);
        }
      }, {
        title: $t("a782ye4", "主体代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        // key: "code",
        minWidth: 100,
        // notShowTable: true,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => {
          return h("span", [row.code || row.uuid]);
        },
        align: "center"
      }, {
        title: $t("a7fnqg4", "主体类型"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "type",
        width: 140,
        align: "center",
        render: (h, {
          row
        }) => {
          return h("div", [h("Tag", {
            "attrs": {
              "color": enterpriseMap[row.type].color
            }
          }, [enterpriseMap[row.type].label])]);
        },
        // notShowTable: true,
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("arlfer4", "加入时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createDatetime",
        align: "center",
        minWidth: 60,
        // notShowTable: true,
        notShowSearch: true,
        notShowForm: true
      }],
      appDetailInfo: {},
      allEntities: []
    };
  },
  computed: {
    height() {
      return window.innerHeight - 360;
    },
    toolBarActions() {
      const h = this.$createElement;
      return [{
        renderItem: () => {
          return h("Button", {
            "attrs": {
              "type": "primary"
            },
            "on": {
              "click": async () => {
                this.addMember();
              }
            }
          }, [$t("e7yhal4", "添加成员")]);
        }
      }, {
        renderItem: () => {
          let flag = this.selections.length > 0;
          return flag ? h("Button", {
            "attrs": {
              "type": "error"
            },
            "on": {
              "click": async () => {
                this.deleteMember();
              }
            }
          }, [$t("eslg2", "删除")]) : null;
        }
      }];
    },
    config() {
      return {
        //配置项
        autoFetch: false,
        columns: this.columns,
        table: {
          draggable: false,
          height: this.height
        },
        toolBarActions: this.toolBarActions,
        request: async page => {
          let params = {
            ...page,
            firstResult: (page.pageNum - 1) * page.pageSize
          };
          let {
            datas,
            firstResult,
            pageSize,
            totalRows
          } = await this.getEntitiesList(params);
          datas = datas.filter(item => item);
          this.selections = [];
          return {
            list: datas,
            pageNum: firstResult / pageSize + 1,
            pageSize,
            total: totalRows
          };
        },
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        map: {
          dataPath: "list",
          totalPath: "total"
        },
        hide: {
          toolBar: true,
          search: true
        }
      };
    }
  },
  methods: {
    searchTable() {
      this.$refs["proTableRef"].searchReset();
      this.selections = [];
    },
    handleSelectionChange(selection) {
      this.selections = selection;
    },
    async addMember() {
      await this.getAllEntitiesList();
      this.$refs["orgTreeModalRef"].open([], this.appDetailInfo);
    },
    async deleteMember() {
      if (!this.selections.length) {
        return this.$Message.error($t("h90bim9", "请选择要删除的主体"));
      }
      let {
        id
      } = this.$route.query;
      let entities = this.selections.map(item => {
        let {
          type,
          uuid
        } = item;
        return {
          entityType: type,
          entityId: uuid
        };
      });
      let params = {
        appId: id,
        entities
      };
      let {
        data: {
          result,
          retVal
        }
      } = await removeEntities(params);
      const currentPage = this.$refs["proTableRef"].page.current;
      const currentDataCount = this.$refs["proTableRef"].proData.length;
      if (currentDataCount <= entities.length && currentPage > 1) {
        // 设置页码为上一页
        this.$refs["proTableRef"].page.current = currentPage - 1;
      }
      if (result === 0) {
        this.$Message.success($t("azeh8z4", "删除成功"));
        this.$refs["proTableRef"].fetch();
        this.$emit("on-update");
      } else {
        this.$Message.error(retVal);
      }
    },
    async getEntitiesList(value) {
      let {
        id
      } = this.$route.query;
      let params = {
        appId: id,
        ...value,
        search: this.search || ""
      };
      let {
        data: {
          result,
          retVal
        }
      } = await queryApp(params);
      if (result === 0) {
        let {
          datas,
          firstResult,
          pageSize,
          totalRows
        } = retVal;
        return {
          datas,
          firstResult,
          pageSize,
          totalRows
        };
      }
    },
    async getAllEntitiesList() {
      let {
        id
      } = this.$route.query;
      let {
        data: {
          result,
          retVal: {
            datas
          }
        }
      } = await queryApp({
        appId: id,
        firstResult: 0,
        pageSize: 9999,
        search: ""
      });
      if (result === 0) {
        this.allEntities = datas;
      }
    },
    async getData({
      addEntities,
      removeEntities
    }) {
      if (addEntities.length > 0 || removeEntities.length > 0) {
        let entitiesTypeMap = {
          ORG: "entity_department",
          USER: "entity_user",
          UNIT: "entity_unit",
          TAG: "entity_position"
        };
        addEntities = addEntities.map(item => {
          let {
            key,
            type
          } = item;
          return {
            entityId: key,
            entityType: entitiesTypeMap[type]
          };
        });
        removeEntities = removeEntities.map(item => {
          let {
            key,
            type
          } = item;
          return {
            entityId: key,
            entityType: entitiesTypeMap[type]
          };
        });
        let {
          id
        } = this.$route.query;
        let params = {
          appId: id,
          addEntities,
          removeEntities
        };
        let {
          data: {
            result
          }
        } = await addApp(params);
        if (result === 0) {
          this.$Message.success($t("pzhzt86", "添加主体成功"));
        }
        this.$refs["proTableRef"].fetch();
        this.selections = [];
        this.getAllEntitiesList();
        this.$emit("on-update");
      }
    }
  },
  mounted() {
    this.$refs["proTableRef"].fetch();
    this.getAllEntitiesList();
  },
  watch: {
    appdetail: function (val) {
      this.appDetailInfo = val;
    }
  }
};